/**
 * SalesAreaTab — extracted from CustomerForm.js for readability.
 * Receives everything via a single `ctx` bag so the parent keeps
 * full ownership of state management. Table + dialog live in `sales-area/`.
 */
import React from 'react';
import SalesAreaTable from './sales-area/SalesAreaTable';
import SalesAreaDialog from './sales-area/SalesAreaDialog';

const SalesAreaTab = ({ ctx }) => {
  const {
    salesAreaData, readOnly, setActiveTab, setShowSaDialog, showSaDialog,
    handleEditSalesArea, handleDeleteSalesArea,
  } = ctx;

  return (
    <>
      <SalesAreaTable
        salesAreaData={salesAreaData}
        readOnly={readOnly}
        onAdd={() => setShowSaDialog(true)}
        onEdit={handleEditSalesArea}
        onDelete={handleDeleteSalesArea}
        setActiveTab={setActiveTab}
      />
      {showSaDialog && <SalesAreaDialog ctx={ctx} />}
    </>
  );
};

export default SalesAreaTab;
